"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Loader } from "lucide-react";
const directoryEntries = [{
  label: "STUDIO",
  value: "Via Roma 10, Milano, MI 20121"
}, {
  label: "TELEFONO",
  value: "+39 02 123 4567"
}, {
  label: "EMAIL",
  value: "info@mirkocolloca.it"
}, {
  label: "ORARI",
  value: "Lunedì — Giovedì, 09:00 — 18:00"
}, {
  label: "CHIUSURA",
  value: "Venerdì — Domenica"
}];
function ReachOutForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="border-t border-b border-[var(--border)] py-12">
        <p className="font-mono text-xs uppercase tracking-[0.18em] text-[var(--muted-foreground)] mb-4">
          N° — RICHIESTA INVIATA
        </p>
        <p className="text-foreground text-xl font-light leading-snug mb-8">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="border border-foreground bg-transparent text-foreground hover:bg-transparent hover:border-[var(--primary)] px-9 py-5 h-auto font-light tracking-[0.04em]">
          Invia un'altra richiesta
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-10">
      <FormField control={control} name="full_name" rules={{
      required: "Il nome è obbligatorio"
    }} render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Nome e Cognome
            </FormLabel>
            <FormControl>
              <Input placeholder="es. Mario Rossi" {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 h-auto text-base text-foreground focus-visible:ring-0 focus-visible:border-[var(--primary)] placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "L'email è obbligatoria",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Inserisci un'email valida"
      }
    }} render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Indirizzo Email
            </FormLabel>
            <FormControl>
              <Input type="email" placeholder="tua.email@esempio.it" {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 h-auto text-base text-foreground focus-visible:ring-0 focus-visible:border-[var(--primary)] placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Telefono
            </FormLabel>
            <FormControl>
              <Input type="tel" placeholder="+39 333 000 0000" {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 h-auto text-base text-foreground focus-visible:ring-0 focus-visible:border-[var(--primary)] placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Specifica il motivo della richiesta",
      minLength: {
        value: 10,
        message: "Il messaggio deve contenere almeno 10 caratteri"
      }
    }} render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Motivo della consulenza
            </FormLabel>
            <FormControl>
              <Textarea rows={4} placeholder="Descrivi brevemente la tua richiesta…" {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 min-h-0 text-base text-foreground resize-none focus-visible:ring-0 focus-visible:border-[var(--primary)] placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="border-t border-b border-[var(--destructive)] py-4">
          <p className="font-mono text-xs uppercase tracking-[0.18em] text-[var(--destructive)]">
            {submitError}
          </p>
        </div>}

      <div className="pt-4">
        <Button type="submit" disabled={isSubmitting} className="bg-[var(--primary)] text-white hover:bg-[var(--primary)]/90 px-9 py-5 h-auto text-base font-light tracking-[0.04em] w-full sm:w-auto">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Invio in corso
            </> : "Invia richiesta"}
        </Button>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)]">
          Risponderemo entro un giorno lavorativo
        </p>
      </div>
    </Form>;
}
export default function Consultation() {
  return <section data-section-id="1613" id="richiedi-un-parere-tecnico" className="bg-background text-foreground py-24 md:py-32 lg:py-44 border-t border-b border-[var(--border)] overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-16 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-16 lg:gap-x-8">
          <div className="lg:col-span-5 relative">
            <div className="lg:sticky lg:top-32">
              <p className="font-mono text-xs uppercase tracking-[0.18em] text-[var(--muted-foreground)]">
                N° 01 — CONTATTI
              </p>

              <div className="relative mt-14">
                <span aria-hidden="true" className="pointer-events-none absolute -top-12 right-0 select-none font-light text-[14rem] md:text-[18rem] lg:text-[22vw] leading-none text-[var(--border)]/30" style={{
                WebkitTextStroke: "1px var(--border)",
                color: "transparent"
              }}>
                  01
                </span>
                <h2 className="font-default relative text-foreground font-extralight leading-[1.02] tracking-tight text-[clamp(2.25rem,4.8vw,4.75rem)]">
                  Richiedi un <em className="italic font-extralight">parere</em>.
                </h2>
              </div>

              <div className="mt-16 border-t border-[var(--border)]">
                {directoryEntries.map((entry, i) => <div key={i} data-index={i} className="grid grid-cols-12 gap-4 py-8 border-b border-[var(--border)]">
                    <p className="col-span-12 sm:col-span-4 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] pt-1">
                      {entry.label}
                    </p>
                    <p className="col-span-12 sm:col-span-8 font-default font-light text-foreground text-[clamp(1.125rem,1.4vw,1.375rem)] leading-snug">
                      {entry.value}
                    </p>
                  </div>)}
              </div>

              <p className="mt-12 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)]">
                STUDIO MEDICO — MILANO, ITALIA
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pl-8 xl:pl-16">
            <FormProvider formKey="technical_opinion_form_forensic_gynecology" formId="technical_opinion_form_forensic_gynecology" sectionName="richiedi-un-parere-tecnico" defaultValues={{
            full_name: "",
            email: "",
            phone: "",
            message: ""
          }} validationRules={{
            full_name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              pattern: "phone"
            },
            message: {
              required: true,
              minLength: 10
            }
          }} submitText="Invia richiesta" successMessage="Grazie. La tua richiesta è stata ricevuta, ti risponderemo al più presto." errorMessage="Si è verificato un errore. Riprova più tardi.">
              <ReachOutForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}